
$(".js-drawer-open-left").on("click",function(){

  if($(window).width() > 750) {
    let index = $(this).index();
    $(".drawer-nav__item__top").hide()
    $(`.drawer-nav__item__top:nth-child(${index})`).show()
    $(`.drawer-nav__item__top:nth-child(${index}) .drawer-nav__has-sublist__top`).addClass("drawer-nav--expanded")
  } else {
    $(".drawer-nav__item__top").show()
  }
  
})

$(window).on("resize", function(){

  $(".js-drawer-close").trigger("click")
  $("drawer-nav--expanded").removeClass("drawer-nav--expanded")
  
})



$("[data-href]").on("click",function(){

  window.location = $(this).attr("data-href")
  
})


$(".announcement-bar").on("click",function(){

  $(".announcement-bar").slideUp();
  $(".announcement-popup").show();
  
})

$(".announcement-popup .close").on("click",function(){

  $(".announcement-popup").hide();
  
})


	$(".shop-button").on("mouseenter",function(){
	  $(".shop-dropdown").show();
	  $(".collections-dropdown,.couture-dropdown").hide();
	});
	
	$(".shop-dropdown").on("mouseleave",function(){
		$(".shop-dropdown").hide();
	});



	$(".collections-button").on("mouseenter",function(){
		$(".collections-dropdown").show();
	  $(".shop-dropdown,.couture-dropdown").hide();
	});


	$(".collections-dropdown").on("mouseleave",function(){
		$(".collections-dropdown").hide();
	});
	

	$(".couture-button").on("mouseenter",function(){
		$(".couture-dropdown").show();
      	$(".shop-dropdown,.collections-dropdown").hide();
	});
	
	$(".couture-dropdown").on("mouseleave",function(){
		$(".couture-dropdown").hide();
	});

	// PRODUCT GRID
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
	
      $(".product-item").on("touchstart",function(){
	  
	  
	  if($(this).find(".product-item__image-wrapper img").length > 1){
	  
        $(this).find(".product-item__image-wrapper img").eq(1).toggleClass("a");
	    $(this).find(".product-item__image-wrapper img").eq(0).toggleClass("a");
	    
	  }
	  
	})
      
    
    }else{

	
	$(".product-item").on("mouseenter",function(){
	  
	  
	  if($(this).find(".product-item__image-wrapper img").length > 1){
	  
	    $(this).find(".product-item__image-wrapper img").eq(0).removeClass("a");
	    $(this).find(".product-item__image-wrapper img").eq(1).addClass("a");
	    
	  }
	  
	}).on("mouseleave",function(){
	  
  
  		if($(this).find(".product-item__image-wrapper img").length > 1){
  
    		$(this).find(".product-item__image-wrapper img").eq(1).removeClass("a");
    		$(this).find(".product-item__image-wrapper img").eq(0).addClass("a");
    
  		}
  
	});

}


if($(".product-item__meta__inner")){
  
  setTimeout(function(){
	$("body").addClass("loaded");
  },200);
  
}


// PRODUCT PAGE

$(".details-button span").on("click", function(){

  $(this).siblings().show();
  $(this).hide();

  if($(this).index() == 1){

    $(".details").slideUp(100);

  }else{

    $(".details").slideDown(100);

  }

});

$(".shownwith-button span").on("click", function(){

  $(this).siblings().show();
  $(this).hide();

  if($(this).index() == 1){

    $(".shownwith").slideUp(100);

  }else{

    $(".shownwith").slideDown(100);

  }

});



if(!$(".template-index").length > 0){

  if($(".main-content") ){
  
    $(".main-content").css({
      "margin-top": $(".site-header-container").outerHeight()
    });
  
  }

}

$(".main-content").css({
//   "min-height": $(window).height() - $("header").outerHeight() - $("footer").outerHeight()
})


if($(".template-index").length > 0){

$(window).on("scroll",function(){
  

    if($(window).scrollTop() > $(".site-header-wrapper").outerHeight()){
      
      	$(".site-header-wrapper").addClass("a");
      
    }else{
      
      	$(".site-header-wrapper").removeClass("a");
    }

});

  }else{
    $(".site-header-wrapper").addClass("a");
  }
  
  


if($("#instagram")){

//   $.ajax({
//     type: "GET", 
//     url: "https://api.instagram.com/v1/users/994160168/media/recent/?access_token=994160168.78df6f08a04e459293cc5ce9af12390b",
//     crossDomain: true,
//     success: function(response) {
//       console.log(response)
//       buildInstagram(response.data);
//     },
//     dataType: "jsonp",
//     error: function(message){
//       console.log("error " + message);
//     }
//   });

//   function buildInstagram(data){
  
//     $.each( data, function( key, value ) {


//       if(key < 18 && value.tags.indexOf("areanyc") > -1){

//         if(value.type == "video"){
//           buildVideo(value);
//         }else if(value.type == "image"){
//           buildImage(value);
//         }
  

//       }
	
//       if($(window).width() > 700){
//       	instagramScroll();
//       }
  
//     });
  
//   }

//     if($(window).width() > 700){
//       	instagramScroll();
//       }
  

  function buildVideo(value){



    var video = value.videos.standard_resolution.url;

    $("#instagram").append("<a href='https://area.nyc/collections/all' target='_blank' class='grid__item medium-up--one-third video'><video autoplay loop muted playsline webkit-playsinline><source src='" + video + "' type='video/mp4'>Your browser does not support HTML5 video.</video></a>");


    // if(value.caption.text.indexOf("Barneysny") > -1){

    //   $("#instagram").append("<a href='https://www.barneys.com/designer/area/N-1mzx6z9' target='_blank' class='grid__item medium-up--one-third' style='background:url("+image+") center/cover'><figcaption>Shop at Barney's</figcaption></a>");
    
    // }else{
      
    //   $("#instagram").append("<a href='" + value.link + "' target='_blank' class='grid__item medium-up--one-third' style='background:url("+image+") center/cover'><img style='opacity:0;pointer-events:none;' class='grid__item' alt='View our Instagram' src='" + image + "'/></a>");
    
    // }
    
  }

  function buildImage(value){

    var image = value.images.standard_resolution.url;


    if(value.caption.text.indexOf("Barneysny") > -1){

      $("#instagram").append("<a href='https://www.barneys.com/designer/area/N-1mzx6z9' target='_blank' class='grid__item medium-up--one-third' style='background:url("+image+") center/cover'><figcaption>Shop at Barney's</figcaption><img style='opacity:0;pointer-events:none;' class='grid__item' alt='View our Instagram' src='" + image + "'/></a>");
    
    }else{
      
      
      
//       $("#instagram").append("<a href='" + value.link + "' target='_blank' class='grid__item medium-up--one-third' style='background:url("+image+") center/cover'><img style='opacity:0;pointer-events:none;' class='grid__item' alt='View our Instagram' src='" + image + "'/></a>");
      $("#instagram").append("<a href='https://area.nyc/collections/all' target='_blank' class='grid__item medium-up--one-third' style='background:url("+image+") center/cover'><img style='opacity:0;pointer-events:none;' class='grid__item' alt='View our Instagram' src='" + image + "'/></a>");
    
    }

  }

$('body').on('click', '#insta-feed img', function() {

  window.location.href = "https://area.nyc/collections/all";
  
});
  
  
function instagramScroll(){

  $(window).on("scroll",function(){
      $("#instagram a:nth-child(1)").css({
        "background-position-x":"-"+$(window).scrollTop()/5+"px"
      });
        
      $("#instagram a:nth-child(3)").css({
        "background-position-x":$(window).scrollTop()/5+"px"
      });
        
      $("#instagram a:nth-child(5)").css({
        "background-position-x":"-"+$(window).scrollTop()/5+"px"
      });
      
      $("#instagram a:nth-child(7)").css({
        "background-position-x":$(window).scrollTop()/5+"px"
      });
        
      $("#instagram a:nth-child(9)").css({
        "background-position-x":$(window).scrollTop()/5+"px"
      });
      
      $("#instagram a:nth-child(11)").css({
        "background-position-x":"-"+$(window).scrollTop()/5+"px"
      });
      
      $("#instagram a:nth-child(13)").css({
        "background-position-x":$(window).scrollTop()/5+"px"
      });
      
      $("#instagram a:nth-child(15)").css({
        "background-position-x":"-"+$(window).scrollTop()/5+"px"
      });
      $("#instagram a:nth-child(17)").css({
        "background-position-x":"-"+$(window).scrollTop()/5+"px"
      });
    }); 
  }
}


// Product Page: Scroll Fix

  var header = $("header").outerHeight();
  var end = $(".product__photos").outerHeight() -  $(".product__details").outerHeight();


  $(window).on("resize",function(){

    end = $(".product__photos").outerHeight() - $(".product__details").outerHeight();

    if( $(window).width() < 700 ) {

      $(".product__details").css({
          "position":"relative",
          "top":"0"
      });

      $(".product__details").height("auto");

      $(window).unbind( "scroll" );

    }else{
      fixedScroll();
      $(".product__details").height($(window).height() - header);
    }

  });

  $("img").on("load",function(){
    
    end = $(".product__photos").outerHeight() - $(".product__details").outerHeight();

  });



  if( $(window).width() > 700 ) {
  
    fixedScroll();
    $(".product__details").height($(window).height() - header);

  } else {
    $(".product__details").css("position", "relative")
  }

  function fixedScroll(){


    $(window).on("scroll",function(){
  if( $(window).width() > 700 ) {
      if($(window).scrollTop() < end){
        
      let announcementHeight = $("#qab_background") ? $("#qab_background").height() : 0;
  
        $(".product__details").css({
          "position":"fixed",
          "top": header + announcementHeight,
          "right":"0",
          "bottom":"auto"
        });
  
      }else{
  
        $(".product__details").css({
          "position":"absolute",
          "top":"auto",
          "bottom":"0",
          "right":"0"
        });
  
      }
  }else {
    $(".product__details").css("position", "relative")
  }
    });
  }


if($(".shownwith")){

  $(window).on("scroll",function(){
    
    
    if($(window).scrollTop() > 50 ){
  
    	$(".shownwith").slideDown();
      
    }else{
      
      	$(".shownwith").slideUp();
    
    }
    
  });

}

// $("#AddToCart-product-template .btn__text").text("Add to Cart")



//     var h5 = $("footer .credit").html();
    
//     $("footer .credit").on("mouseenter",function(){
	
// 		$(this).html("<a target='_blank' href='http://jon-l.com'>WEBSITE BY JON-L.COM</a>")
	
// 	}).on("mouseleave",function(){
	
// 		$(this).html(h5)
	
// 	});
    